import { render, staticRenderFns } from "./EventSchedule.vue?vue&type=template&id=50825518&scoped=true&"
import script from "./EventSchedule.vue?vue&type=script&lang=js&"
export * from "./EventSchedule.vue?vue&type=script&lang=js&"
import style0 from "./EventSchedule.vue?vue&type=style&index=0&id=50825518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50825518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
